/* global Sys, Utils, Services */

Sys.ns("Core");

/**
 * ### Spin Gift
 *
 * Provide functionality to handle Spin Gift from OSS.
 *
 */
Services.IntegrationSpinGift = {
    SPIN_GIFT_STATUS: {
        REWARD_ON_HOLD: "rewardOnHold",
        INACTIVE: "inactive"
    },
    _isInSpinGift: false,

    /**
    * Initialize SpinGift object.
    *
    * @param {Object} integration Integration module.
    *
    * @returns {this} SpinGift object.
    */
    init: function(integration) {
        this._addListener = integration.addListener.bind(integration);
        this._removeListener = integration.removeListener.bind(integration);

        return this;
    },

    /**
     * Triggers Spin Gift start.
     *
     * @returns {void}
     */
    startSpinGift: function() {
        this._removeListener("notify:integrationBalanceId.reInit");

        Services.gameRound.removeStartBlocker();

        Services.freeRounds.acceptFreeRounds();
        Services.freeRounds.start();
        Services.freeRounds.confirmationResolved();
    },

    /**
     * Triggers Spin Gift end.
     *
     * @returns {void}
     */
    endSpinGift: function() {
        this._removeListener("notify:integrationBalanceId.reInit");

        Services.gameRound.removeStartBlocker();

        this._isInSpinGift = false;
    },

    /**
     * Handles Spin Gift start.
     *
     * @returns {void}
     */
    prepareSpinGiftStart: function() {
        this._isInSpinGift = true;

        Services.gameRound.addStartBlocker();

        Services.autoplay.stop();

        this._addListener("notify:integrationBalanceId.reInit", this.startSpinGift.bind(this));
    },

    /**
     * Handles Spin Gift end.
     *
     * @returns {void}
     */
    prepareSpinGiftEnd: function() {
        Services.gameRound.addStartBlocker();

        Services.freeRounds.end();

        this._addListener("notify:integrationBalanceId.reInit", this.endSpinGift.bind(this));
    },

    /**
     * Handles SpinGift status.
     *
     * @param {string} status Status.
     *
     * @returns {void}
     */
    handleStatusUpdate: function(status) {
        if (status === this.SPIN_GIFT_STATUS.REWARD_ON_HOLD) {
            this.prepareSpinGiftStart();
        }
        else if (status === this.SPIN_GIFT_STATUS.INACTIVE && Services.freeRounds.isActive()) {
            this.prepareSpinGiftEnd();
        }
    },

    /**
     * Either game is in Spin Gift feature or not.
     *
     * @returns {boolean} Return true if in Spin Gift feature.
     */
    isInSpinGift: function() {
        return this._isInSpinGift;
    },

    /**
     * Handles dialog requet in Spin Gift.
     *
     * @param {string} dialogName Dialog name.
     *
     * @returns {void}
     */
    handleDialog: function(dialogName) {
        if (dialogName === Utils.CONSTANTS.DIALOG_NAMES.FREE_ROUNDS_END) {
            this.prepareSpinGiftEnd();
        }
    }
};
